// @tenorlab/nuxt-dashboard-pro
// file: app/config/index.ts
// file: src/config/index.ts
// returns appropriate config based on env NUXT_PUBLIC_APP_CONFIG

// import a reference to our Config interface:
import type { IConfig } from './models/Config.interface'

// import reference to configFilesMap
import { configFilesMap } from './config-files-map'
import * as pkg from '../../package.json'

// import reference to our getAppConfigKey helper function
import { getAppConfigKey } from '@/utils/'

export * from './models/Config.interface'

let _instance!: IConfig

export const useConfig = (configKey?: string) => {
  const _logger = console

  if (!_instance) {
    if (typeof configKey === 'undefined') {
      configKey = getAppConfigKey()
    }

    let key = configKey as string
    if (!configFilesMap.has(key)) {
      _logger.warn(`Could not find config for NUXT_PUBLIC_APP_CONFIG "${key}". Defaulting to "dev"`)
      key = 'dev'
    }

    _logger.info(`------ env ------ "${key}"`)

    // get config from lookup map
    const config = configFilesMap.get(key) as IConfig
    config.configKey = key
    // set packageVersion (from package.json)
    config.global.packageVersion = pkg.version

    // // setup themes
    // const themes = config.themes || []
    // let defaultTheme = themes.find((x) => x.selected)
    // if (!defaultTheme) {
    //   // default to first
    //   defaultTheme = config.themes[0]
    // }
    // config.themes = themes.map((x) => {
    //   x.selected = x.id === defaultTheme?.id
    //   x.id = (x.id || '').trim().toLowerCase()
    //   return x
    // })

    _instance = config
  }

  return _instance
}
